import { ROLE_TYPE } from "@supplier/meta";
import salesManageRouter from "./salesManage";
import purchasingManageRouter from "@/routers/purchaseSalesInventory/purchaseManagement";
import contractRouter from "@/routers/purchaseSalesInventory/contractManagement";
import fundRouter from "@/routers/purchaseSalesInventory/fundMangement";
import financingRouter from "@/routers/purchaseSalesInventory/financing";
import invoiceRouter from "@/routers/purchaseSalesInventory/invoice";
import storageRouter from "@/routers/purchaseSalesInventory/storage";
import logisticsRouter from "@/routers/purchaseSalesInventory/logistics";
import statementStatisticsRouter from "@/routers/purchaseSalesInventory/statementStatistics";
import accountsPayableRouter from "@/routers/purchaseSalesInventory/accountsPayable";
import { UserStore } from "@/stores/user";
import { hasPurchaseSalesInventory } from "@/utils/permission";
import { AccountStore, AccountType } from "@/stores/account";

export const purchaseSalesInventoryRouters = [
    {
        path: "/purchaseSalesInventory",
        name: "PurchaseSalesInventory",
        meta: {
            title: "进销存管理",
            icon: "icon-jinxiaocun",
            auth: ({ userStore, accountStore }: { userStore: UserStore; accountStore: AccountStore }) => {
                let roles = userStore.userInfo.proxyAccount?.roles;
                // 关联企业是跟随主账号的角色权限
                if (accountStore.accountType === AccountType.ASSOCIATED) {
                    roles = userStore.userInfo.customer?.roles;
                }
                return (
                    !!roles?.includes(ROLE_TYPE.PURCHASE_CUSTOMER.code) &&
                    (!accountStore.isSubAccount || hasPurchaseSalesInventory(userStore.userInfo.permissions))
                );
            }
        },
        children: [
            ...purchasingManageRouter,
            ...salesManageRouter,
            ...contractRouter,
            ...fundRouter,
            ...financingRouter,
            ...accountsPayableRouter,
            ...invoiceRouter,
            ...logisticsRouter,
            ...storageRouter,
            ...statementStatisticsRouter
        ]
    }
];
